import AdminAiScanReview from "../components/ai-scans/AdminAiScanReview";
import { useAdminAiScanReports } from "../hooks/useAdminAiScanReports";

// Reads validation reports only while this page is mounted.
// Keeps the expected and observed controls beside the invalid shape and unsafe outcome.
// Review coverage remains separate from findings so an empty result does not imply complete validation.
const AdminAiValidationsScanPage = () => {
  const { reports, featureReports, issues, loading, error, refresh, available } = useAdminAiScanReports("validations");

  return (
    <AdminAiScanReview
      scan="validations"
      title="Validations"
      description="Review frontend and backend validation by module, business object, surface and feature. Compare expected controls with observed validation, then follow the invalid shape to its unsafe outcome and proposed remediation. Coverage distinguishes reviewed boundaries from weak or unreviewed areas."
      featureReviewKey="featureValidations"
      findingFields={[
        "boundary",
        "expectedValidation",
        "observedValidation",
        "invalidShape",
        "unsafeOutcome",
        "explanation",
        "filePath",
        "line",
        "symbol",
        "remediation",
        "affectedFeatureIds",
        "canonicalKey",
      ]}
      reports={reports}
      featureReports={featureReports}
      issues={issues}
      loading={loading}
      error={error}
      available={available}
      onRefresh={refresh}
    />
  );
};

export default AdminAiValidationsScanPage;
